"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Logger {
}
exports.default = Logger;
//# sourceMappingURL=Logger.js.map